import tr from './tr.json';
import en from './en.json';

/** i18next namespace this package owns. */
export const NS = 'ui';

/**
 * Base translation catalogue for the `ui` namespace.
 *
 * <p>This is the shipped floor. Tenant overrides fetched from the i18ln backend
 * are layered over it at runtime by `TenantI18nOverridesSync`, so editing a
 * label here changes the default for every institution that has not overridden
 * it — and changes nothing for one that has.
 */
export const locales = [{ ns: NS, resources: { tr, en } }];
